import React from "react";
import { Link } from "gatsby";
import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faChevronDown } from "@fortawesome/pro-light-svg-icons";

import chevronDownIco from '../../assets/icons/k-chevron-down-ico.svg';

const SpanChevronDownIco = styled.span`

display: inline-block;
height: 1rem;
width: 1rem;
transform: translateY(3px);
margin-right: -15px;
background-color: #009A49;
mask-image: url("${chevronDownIco}");
mask-repeat: no-repeat;
mask-position: center;
mask-size: contain;
`;

const NavStyles = styled.nav`
    #menu-toggle {
        span {
            transition: transform ease-in-out .2s;
        }
    }
    #menu-toggle.active {
        span {
            background: #fff;
            
            &:nth-child(1) {
                transform-origin: 0 50%;
                transform: rotate(40deg)
            }
            &:nth-child(2) {
                transform: scale(0)
            }
            &:nth-child(3) {
                transform-origin: 0 50%;
                transform: rotate(-40deg)
            }
        }

        @media screen and (max-width: 1100px) {
            position: fixed;
            top: calc(5.8125rem);
            right: 1.25rem;
        }
    }

    &.active {
        #main-menu {
            @media screen and (max-width: 1100px) {
                position: fixed;
                top: 0;
                left: 0;
                padding-top: 3.8125rem;
            }
        }
    }
`;

function toggleMenu(e) {
    // 1. change button to active (colours)
    e.currentTarget.classList.toggle('active');
    // 2. display menu
    // document.getElementById('main-menu').classList.toggle('-translate-x-full')
    // document.getElementById('main-menu').classList.toggle('opacity-30')
    var mainMenu = document.getElementById('main-menu');
    mainMenu.parentElement.classList.toggle('active')
    mainMenu.classList.toggle('-translate-x-full')
    mainMenu.classList.toggle('opacity-30')
}

export default function Nav() {

    const handleNavClick = e => {
        var navToggleBtn = {
            currentTarget: document.getElementById('menu-toggle')
        }
        toggleMenu(navToggleBtn);
    }
    
    return (
        <NavStyles className="justify-self-end">
            <button type="button" id="menu-toggle" aria-label="menu toggle" className="relative z-50 lg:hidden" onClick={toggleMenu}>
                <span className="block mb-2 h-2-px w-8 bg-primary"></span>
                <span className="block mb-2 h-2-px w-8 bg-primary"></span>
                <span className="block mb-2 h-2-px w-8 bg-primary"></span>
            </button>
            <ul id="main-menu" className="absolute top-12 left-0 z-40 h-screen lg:h-auto py-5 transform -translate-x-full opacity-30 transition duration-200 lg:flex items-center list-none bg-primary w-full lg:bg-transparent lg:w-auto lg:transform-none lg:opacity-100 lg:static lg:py-0">
                <li>
                    <Link to="/articles" className="block py-2 px-4 font-bold text-white lg:text-primary lg:hover:text-primary-darker" onClick={e => handleNavClick(e)}>Articles</Link>
                </li>
                <li>
                    <Link to="/product-range" className="block py-2 px-4 font-bold text-white lg:text-primary lg:hover:text-primary-darker" onClick={e => handleNavClick(e)}>Product range</Link>
                </li>
                <li className="relative group">
                    <span className="block py-2 px-4 font-bold text-white lg:text-primary">Applications <SpanChevronDownIco /></span>
                    <ul className="bg-primary lg:hidden lg:absolute lg:top-full lg:w-52 lg:shadow-xl lg:group-hover:block lg:group-hover:opacity-100">
                        <li className="text-white px-8 py-1 lg:px-4 lg:hover:bg-primary-darker"><Link to="/applications/gas-chromatography" className="block" onClick={e => handleNavClick(e)}>Gas Chromatography</Link></li>
                        <li className="text-white px-8 py-1 lg:px-4 lg:hover:bg-primary-darker"><Link to="/applications/electronics" className="block" onClick={e => handleNavClick(e)}>Electronics</Link></li>
                    </ul>
                </li>
                <li>
                    <Link to="/technology" className="block py-2 px-4 pr-0 font-bold text-white lg:text-primary lg:hover:text-primary-darker" onClick={e => handleNavClick(e)}>Technology &amp; Specification</Link>
                </li>
                <li>
                    <Link to="/calculator" className="block py-2 px-4 font-bold text-white lg:text-primary lg:hover:text-primary-darker" onClick={e => handleNavClick(e)}>BIP<sup>&reg;</sup> Calculator</Link>
                </li>
            </ul>
        </NavStyles>
    )
}